
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'BalLoadingBlock',

  props: {
    white: { type: Boolean, default: false },
    darker: { type: Boolean, default: false },
    rounded: {
      type: String,
      default: 'lg',
      validator: (val: string): boolean => ['sm', 'md', 'lg'].includes(val)
    }
  },

  setup(props) {
    const bgClass = computed(() => {
      if (props.white) return 'shimmer-white';
      return props.darker ? 'shimmer-light-mode-darker' : 'shimmer-light-mode';
    });

    const classes = computed(() => {
      return {
        [`rounded-${props.rounded}`]: true,
        [bgClass.value]: true
      };
    });

    return { classes };
  }
});
